/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const LabelBox = styled.div`
  display: flex;
  margin-top: 32px;
  margin-bottom: 8px;
  align-items: center;
  justify-content: space-between;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputBox = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const InputWrap = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 8px;
`;

export const DisabledBox = styled.div`
  width: 100%;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
